


















































import { Component, Inject, Prop, Vue, Emit } from 'vue-property-decorator';
import { splitColumns, groupLists } from './helpers';
import { IMenuItem, IPermission, IMenuItemsWrapper, IGroupedItems, IMenuLink } from '.';
import SecondLevelMenuItem from './_SecondLevelMenuItem.vue';

interface ComputedMenuItem {
    type: 'GroupHeader';
    caption: string;
    permission?: IPermission;
    items: IMenuItem[];
}

@Component({
    components: {
        SecondLevelMenuItem
    }
})
export default class Menu extends Vue {
    private hoverTimeout: any = 0;

    @Inject({ default: null }) public menuState: {
        activeIndex: number | undefined;
        menuIsOpen: boolean | undefined;
    };
    @Inject() public events: IMenuItemsWrapper;

    @Prop({ required: true }) public menuIndex: number;
    @Prop({ required: true }) public caption: string;
    @Prop({ default: () => [] }) public items: IMenuItem[];
    @Prop() public secondLevelIsOpen: boolean;

    public toggleMenu(): void {
        this.$emit('toggle-dropdown', this.menuIndex);
    }

    public resetThirdLevels(): void {
        this.$children.forEach((thirdLevel) => {
            thirdLevel.$data.showThirdLevel = false;
        });
    }

    public hoverMenu(): void {
        if (this.hoverTimeout > 0) {
            clearTimeout(this.hoverTimeout);
        }

        this.hoverTimeout = setTimeout(() => {
            this.$emit('menu-hovering', this.menuIndex);
        }, 100);
    }

    public hoverLeave(): void {
        clearTimeout(this.hoverTimeout);
    }

    public get showMenu(): boolean {
        return this.secondLevelIsOpen && this.menuIndex === this.menuState.activeIndex;
    }

    public get menuId(): string {
        return this.caption.replace(/\s/g, '-').toLowerCase().concat('-menu');
    }

    public get computedItems(): [ComputedMenuItem[], ComputedMenuItem[]] {
        if (this.events.menuItems) {
            let groupedEvents = groupLists(this.events.menuItems as any);
            this.items.forEach((item) => {
                if (item.type != "GroupHeader" && item.type != "ColumnBreak") {
                    groupedEvents.forEach((event) => {
                        if (event.caption && item.caption && matchEventMenuItem(event, item)) {
                            item.events = event;
                        }
                    });
                }
            });
        }

        return splitColumns(this.items)
            .map(groupLists)
            .filter((x: ComputedMenuItem[]) => x.length > 0);
    }

    @Emit('navigate') public navigate(e: Event) { return e; }

}

function matchEventMenuItem(eventMenu: IGroupedItems, itemMenu: IMenuLink) {
    const rxDataSipMenu = /data-sip-menu=[\'\"](?<menuId>.*)[\'|\"]/i;
    const menuId = rxDataSipMenu.exec((itemMenu as any)?.html)?.groups?.menuId;
    
    if ((eventMenu as any) !== null && (eventMenu as any).id === menuId) {
        return true;
    } else {
        return eventMenu.caption.toLowerCase() === itemMenu.caption.toLowerCase()
    }
}

